import React from 'react';
import { Column, Grid, Row, cls } from 'packages/components';
import Asset from '../../../requests/apa/Asset';
import './styles/contentPlays.scss';
import SearchConstants from '../SearchConstants';
import Device from '../../../devices/device';
import { Pin } from '../../../AAF/Pin/main';
const getAssetPlay = () => {
    return Asset.get('icon_play_modal_episode', '/images/ic_play.png');
};


const WrapperContentPlay = ({ onFocus = null, isPlay = false, children_left =  null, children_right, onClick = null, item={}, isFuture = false }) => {
    const device = Device.getDevice().getPlatform();

    const {channel_group = {}, id:groupId = null} = item;
    const group_id = channel_group && channel_group.common ? channel_group.common.id : groupId;

    const blockedChannel = Pin.blockedChannelsList().includes(group_id)
    const showButtonPlay = isPlay && !isFuture && !blockedChannel

    return (
        <Grid className={cls('aaf_main_search_content_play_main', (isPlay ? 'aaf_main_search_content_play_main_isPlay':''))}>
            <Row className={cls('aaf_main_search_content_play_main_row')}>
                <Column lg={6} className={cls('aaf_main_search_content_play_main_col')}>
                    <a  onFocus = {onFocus} id={`${SearchConstants.FOCUSABLE_CARD}_${item.idx_temp}`} tabindex={0} href="javascript:void(0)" className={cls('aaf_grid aaf_main_search_content_play_main_grid_children ', SearchConstants.FOCUSABLE)} onClick={() => {
                        (typeof onClick === 'function') && onClick()
                    }} data-id={item.idx_temp || null} data-from-focusable ={SearchConstants.FOCUSABLE_CARD}>
                        <Row className={cls('aaf_main_search_content_play_main_row_children')}>
                            <Column lg={12} className={cls('aaf_main_search_content_play_main_col_children')}>
                                <div className={cls(device !== 'ps4' ? 'aaf_main_search_content_play_main_col_parent': 'aaf_main_search_content_play_main_col_parent_ps4')}>
                                    <div className="aaf_main_search_content_play_main_col_parent_image">
                                        {children_left}
                                    </div>

                                    {showButtonPlay && <div className="aaf_main_search_content_play_main_col_parent_icon_play">
                                        <img
                                            src={getAssetPlay()}
                                            className={cls(
                                                'aaf_main_search_content_play_main_col_parent_icon_play_asset'
                                            )}
                                            alt='icon_play'
                                        />
                                            </div>}
                                </div>
                            </Column>
                        </Row>
                    </a>
                </Column>
                <Column lg={6} className={cls('aaf_main_search_content_play_main_col aaf_main_search_content_play_main_col_left')}>
                    <Grid className={cls('aaf_main_search_content_play_main_grid_children')}>
                        <Row className={cls('aaf_main_search_content_play_main_row_children')}>
                            <Column lg={12} className={cls('aaf_main_search_content_play_main_col_children')}>
                                {children_right}
                            </Column>
                        </Row>
                    </Grid>
                </Column>
            </Row>
        </Grid>
    );
};

export default WrapperContentPlay;



// WEBPACK FOOTER //
// ./src/containers/Search/components/WrapperContentPlay.jsx